import { render, staticRenderFns } from "./BudgetGauge.vue?vue&type=template&id=c34450b8&scoped=true&"
import script from "./BudgetGauge.vue?vue&type=script&setup=true&lang=js&"
export * from "./BudgetGauge.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BudgetGauge.vue?vue&type=style&index=0&id=c34450b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34450b8",
  null
  
)

export default component.exports